<script setup lang="ts">
  import { ref } from 'vue'
  import { Plus } from 'lucide-vue-next'
  import { Button } from '@/components/ui/button'
  import AddWidgetsDialog from './addWidgetsDialog.vue'
  import { useTranslation } from '@/composables/useTranslation'

  const { t } = useTranslation({
    en: {
      addWidgets: 'Add Widgets'
    },
    de: {
      addWidgets: 'Widgets hinzufügen'
    }
  })

  const dialogOpen = ref(false)

  const openDialog = () => {
    dialogOpen.value = true
  }
</script>

<template>
  <div>
    <Button
      variant="secondary"
      class="flex items-center gap-2"
      @click="openDialog"
    >
      <Plus class="h-5 w-5" />
      {{ t('addWidgets') }}
    </Button>

    <AddWidgetsDialog v-model:open="dialogOpen" />
  </div>
</template>
